export default __webpack_public_path__ + "static/media/1.5c1d2f51.webp";